import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "customPath": "about/skoda-why/sport",
  "description": "ŠKODA и спорт",
  "keywords": "skoda-why sport",
  "name": "sport",
  "title": "ŠKODA и спорт"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SimpleMainStage = makeShortcode("SimpleMainStage");
const SimpleMainStageHeading = makeShortcode("SimpleMainStageHeading");
const DefaultPaddedSection = makeShortcode("DefaultPaddedSection");
const DefaultSectionText = makeShortcode("DefaultSectionText");
const DefaultSectionHeading = makeShortcode("DefaultSectionHeading");
const QueriedGallery = makeShortcode("QueriedGallery");
const VideoPlayer = makeShortcode("VideoPlayer");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <SimpleMainStage verticalAlign="bottom" horizontalAlign="left" src="/m/tp-family-top.jpg" mobileSrc="/m/tp-family-top.jpg" mdxType="SimpleMainStage">
  <SimpleMainStageHeading mdxType="SimpleMainStageHeading">ВСЕГДА ВПЕРЕДИ</SimpleMainStageHeading>
    </SimpleMainStage>
    <DefaultPaddedSection bgColor="#FAFAFA" noPb mdxType="DefaultPaddedSection">
  <DefaultSectionText fullWidth mdxType="DefaultSectionText">
    <p>
      Дух соревновательности — в природе человека. Иначе чем можно объяснить
      присущее каждому из нас стремление стать лучше, желание доказать себе и
      окружающим, что мы способны на большее? Спорт как вид человеческой
      деятельности — один из самых честных способов выяснения отношений между
      людьми. Понятные правила, наглядный результат. А ещё — эмоции. Здоровые
      эмоции, объединяющие нас. Когда мы болеем за своих: за любимую команду, за
      конкретного спортсмена или страну в целом, то отдаёмся этому чувству
      искренне, всей душой. Спорт — то немногое, что по доброй воле объединяет
      людей разного возраста, разных взглядов на жизнь и, что скрывать, разного
      достатка. Вот почему ŠKODA поддерживает спортивные состязания. Ближе всего
      чешской марке три дисциплины: хоккей, велогонки и ралли. Почему? Сейчас
      расскажем!
    </p>
  </DefaultSectionText>
    </DefaultPaddedSection>
    <DefaultPaddedSection bgColor="#FFF" noPb mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading">ŠKODA и хоккей</DefaultSectionHeading>
  <DefaultSectionText fullWidth mdxType="DefaultSectionText">
    <p>
      Что связывает Россию и Чехию? Ну конечно, любовь к марке ŠKODA. А ещё?
      Любовь к хоккею! В обеих странах хоккей — больше чем командная игра. И в
      России, и в Чехии считают свою национальную сборную лучшей в мире, просто
      когда-то их парням везёт, а когда-то — не очень. Для ŠKODA хоккей — самый
      главный на свете вид спорта. Честная и открытая схватка, сильный командный
      дух, без которого немыслима победа, динамика и напор — эти характеристики
      игры близки и понятны ŠKODA. Для многих семей просмотр телевизионных
      трансляций матчей — одна из тех немногих традиций, что выдержали испытание
      временем. А семья для ŠKODA — это святое.
    </p>
    <p>
      В 2017 году марка отметит уникальный юбилей, в 25-й раз выступив в
      качестве генерального спонсора чемпионата мира по хоккею. У ледовых арен в
      Париже и Кёльне будут стоять ряды белоснежных ŠKODA, на которых, как
      обычно, станут передвигаться спортсмены, судьи, организаторы и «очень
      важные гости». Миллионы зрителей по всему миру будут наблюдать огромный
      логотип марки по центру хоккейных площадок, где определится сильнейшая
      команда планеты. С 2007 года ŠKODA представлена в Книге рекордов Гиннесса
      за «самое продолжительное главное спонсорство мирового чемпионата», и
      после каждого турнира рекорд обновляется.
    </p>
  </DefaultSectionText>
    </DefaultPaddedSection>
    <DefaultPaddedSection bgColor="#FFF" noPb mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading">Партнерство</DefaultSectionHeading>
    </DefaultPaddedSection>
    <QueriedGallery presetName="6" tags="skoda-why sport" mdxType="QueriedGallery" />
    <DefaultPaddedSection bgColor="#FFF" noPb mdxType="DefaultPaddedSection">
  <DefaultSectionText fullWidth mdxType="DefaultSectionText">
    <p>
      Многое делает ŠKODA и для развития хоккея в нашей стране. Автомобили ŠKODA
      — точно так же, как и во время чемпионатов мира, — возят спортсменов,
      организаторов и гостей проводимых под эгидой федерации мероприятий, а
      также заняты ежедневным транспортным обслуживанием работников федерации,
      на счету которых —подготовка десятков соревнований, проходящих в течение
      года. В их числе — и Кубок Первого канала, российский этап Еврохоккейтура,
      на котором ŠKODA имеет статус официального партнёра состязания. Автомобили
      чешской марки, установленные на всеобщее обозрение на стадионах, в
      непосредственной близости от ледовых площадок, и логотипы ŠKODA на форме
      игроков нашей сборной — неизменные приметы Кубка Первого канала на
      протяжении последних лет. Любопытная деталь. Кубок Первого канала имеет
      давнюю историю: с 1969 по 1996 год он был известен, причём далеко за
      пределами границ СССР, как турнир на приз газеты «Известия». Так что
      знаменитый талисман соревнования, добродушный Снеговик с носом-морковкой и
      клюшкой в руках, — привет из той поры. Снежный человечек прошёл с нами
      «через годы, через расстоянья». Связь времён — великая вещь.
    </p>
  </DefaultSectionText>
    </DefaultPaddedSection>
    <DefaultPaddedSection bgColor="#FAFAFA" noPb mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading">
    Юношеский турнир по хоккею ŠKODA
  </DefaultSectionHeading>
  <DefaultSectionText fullWidth mdxType="DefaultSectionText">
    <p>
      Думает ŠKODA и о том, кто будет выступать в составе сборной команды России
      завтра. И многих звёзд отечественного хоккея, которым суждено представлять
      нашу страну в чемпионатах мира будущих лет, знает поимённо. Каким образом?
      Очень просто. С 2012 года ŠKODA проводит в России собственный детский
      хоккейный турнир. В нём принимают участие юношеские команды из разных
      уголков страны. С 2016 года турнир ŠKODA Junior Ice Hockey Cup вышел на
      принципиально новый уровень. Важное уточнение: отбор юношеских команд,
      приглашаемых ŠKODA в Москву на первенство, осуществляется при
      непосредственном участии федерации. Это позволяет собрать команды примерно
      одного уровня. Говоря по-простому, ŠKODA приглашает лучших ребят, играющих
      в хоккей. Присмотритесь к их лицам. Наверняка среди них есть будущие
      чемпионы мира, ими будет гордиться Россия.
    </p>
  </DefaultSectionText>
    </DefaultPaddedSection>
    <DefaultPaddedSection bgColor="#FFF" noPb mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading">С чего начинала компания ŠKODA?</DefaultSectionHeading>
  <DefaultSectionText fullWidth mdxType="DefaultSectionText">
    <p>
      С производства велосипедов. Так что тяга к велоспорту у марки, что
      называется, в крови. С 2004 года ŠKODA выступает главным автомобильным
      партнёром «Тур де Франс», самой сложной и известной велогонки в мире. И
      очень, заметим, популярной. По числу зрителей, следящих за развитием
      событий, «Тур де Франс» уступает только чемпионату мира по футболу и
      Олимпийским играм. Иными словами, среди спортивных мероприятий, проводимых
      ежегодно, конкурентов у «Тур де Франс» нет.{" "}
    </p>
  </DefaultSectionText>
    </DefaultPaddedSection>
    <VideoPlayer padding="16/9" previewSrc="/m/skoda_sport.jpg" videoSrc={{
      "video/mp4": "/m/skoda-sport-tdf.mp4"
    }} mdxType="VideoPlayer" />
    <DefaultPaddedSection bgColor="#FFF" noPb mdxType="DefaultPaddedSection">
  <DefaultSectionText fullWidth mdxType="DefaultSectionText">
    <p>
      То, чем велоспорт привлекает сотни миллионов людей по всему миру, очень
      доходчиво объясняет Стивен Рош, победитель «Тура» 1987 года, а ныне —
      посол марки ŠKODA на соревновании. «Велосипед, — рассуждает Стивен Рош,
      —замечательный спортивный снаряд. Он знаком практически всем и приносит
      удовольствие практически в любом возрасте: и в два года, и в восемьдесят
      два. Кататься на велосипеде можно как большой компанией, так и в одиночку.
      Наконец, и гонки с участием профессиональных спортсменов устроены очень
      демократично: покупать билет не требуется, чтобы увидеть всё воочию,
      достаточно просто встать на обочину».
    </p>
    <p>
      Посмотрите репортаж с «Тур де Франс» — сколько людей лично поддерживает
      гонщиков! Многие тысячи, от мала до велика, забыв про дела и заботы,
      приходят на праздник спорта.
    </p>
    <p>
      Каждый год ŠKODA направляет около 250 автомобилей для обслуживания «Тур де
      Франс». За три недели машины суммарно проезжают примерно 2,8 млн км.
      Директор гонки также перемещается исключительно на ŠKODA. В качестве
      передвижного командного пункта, так называемого красного автомобиля,
      выступает флагманская модель марки, ŠKODA SUPERB. Специально оборудованную
      машину, в которую стекается вся информация о ходе гонки для принятия
      важнейших организационных решений, постоянно видят во главе пелотона более
      1,5 млрд человек, следящих за соревнованием. Маршрут гонки каждый год
      меняется, но финальный этап традиционно проходит по Елисейским полям. В
      июле 2016 года по главной улице Парижа гонщиков «провёл» ŠKODA KODIAQ —
      автомобиль на тот момент настолько новый, что его внешность пришлось
      изменить за счёт камуфляжа, чтобы не раскрывать интригу раньше времени.
      Осенью 2016 года KODIAQ попал в число главных мировых премьер Парижского
      автосалона, представ перед публикой во всей красе.
    </p>
    <p>
      Участие в «Тур де Франс» для марки ŠKODA очень символично еще и по той
      причине, что к 1903 году, когда состоялся первый в истории «Тур», компания
      из Млада-Болеслава уже была признанным экспертом в деле производства
      двухколёсной техники. Об этих славных страницах истории рассказывает
      экспозиция заводского музея ŠKODA, museum.skoda-auto.com.
    </p>
    <p>
      То, что для ŠKODA велосипеды являются вторым по важности средством
      передвижения после автомобилей, прослеживается не только на уровне
      поддержки гонок с участием звёзд мирового уровня. Марка по мере сил и
      средств несёт велоспорт, как было принято говорить раньше, в массы. В
      числе оригинальных аксессуаров, предлагаемых дилерами ŠKODA, вы найдёте
      фирменные велосипеды для взрослых и детей, сделанные в сотрудничестве с
      авторитетными европейскими производителями. В скором времени коллекция
      должна пополниться стильными городскими моделями: всё больше людей в
      России и в мире видят в велосипедах не только средство для активного
      отдыха, но и удобный транспорт на каждый день, преимущества которого
      становятся всё более заметными в условиях современного мегаполиса.
    </p>
    <p>
      Все без исключения модели автомобилей ŠKODA отлично приспособлены для
      перевозки велосипедов. Если по какой-то причине двухколёсной машине не
      найдётся места в салоне, с помощью специализированных креплений, которые
      также предлагаются в качестве оригинальных аксессуаров, вы быстро и
      надёжно установите велосипед на крышу автомобиля.
    </p>
    <p>
      Теме «велоспорта для всех и для каждого» посвящён поддерживаемый маркой
      международный сайт www.welovecycling.com. Отчёты о путешествиях, блоги,
      исторические подборки, советы по безопасному вождению и даже рекомендации
      по велодиете будут интересны тем, кто в той или иной степени владеет
      английским языком.
    </p>
  </DefaultSectionText>
    </DefaultPaddedSection>
    <DefaultPaddedSection bgColor="#FAFAFA" noPb mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading">
    Знаете ли вы, как многим в современном автомобиле мы обязаны автоспорту?
  </DefaultSectionHeading>
  <DefaultSectionText fullWidth mdxType="DefaultSectionText">
    <p>
      Мощные, но лёгкие моторы, в том числе и турбированные, прежде всего
      доказали своё право на существование в гонках. Эффективные дисковые
      тормоза, позволяющие раз за разом осаживать автомобиль с высокой скорости,
      первыми были востребованы у спортсменов. Коробка, переключающая передачи
      за доли секунды без разрыва потока мощности, известная сегодня под
      аббревиатурой DSG, тоже появилась по требованию тех, для кого каждое
      мгновение за рулём автомобиля бесценно. О том, насколько важна в
      автоспорте отточенная управляемость, и говорить нечего. От неё зависит не
      только победа, но часто — и сама жизнь.
    </p>
    <p>
      История марки из чешского города Млада-Болеслава неразрывно связана с
      участием в гонках. Иначе у компании, стоявшей у истоков мирового
      автомобилестроения, и быть не могло.
    </p>
    <p>
      Началось всё более 115 лет назад с курьёза. Первый «боевой опыт» компания
      — тогда она называлась Laurin & Klement и производила не автомобили (они
      пошли в серию с 1905 года), а мотоциклы — получила летом 1901 года. Тогда
      сотрудник предприятия Нарцис Подседничек, конструктор, рабочий, мастер на
      все руки, первым среди участников гонки Париж — Берлин преодолел 1196 км,
      отделявших столицу Франции от столицы Германии. Только рекорд ему не
      засчитали: Подседничек прибыл к месту финиша в три часа ночи, когда
      организаторы, не ожидавшие такой прыти от участника, ещё спали. А
      вымотанный дорогой гонщик ушёл отдыхать в гостиницу.
    </p>
    <p>
      С тех пор было много побед, засчитанных и заслуженных побед, в том числе и
      в дореволюционной России. Автомобили чешской марки оказывались первыми во
      многом и потому, что были отлично приспособлены к дорогам не самого
      лучшего качества, каковые преимущественно и имелись в Российской империи.
      Более именитым и дорогим конкурентам зачастую не хватало запаса прочности,
      чтобы дойти без приключений до финиша.
    </p>
    <p>
      Прошло много времени, но вот что интересно. В городе Млада-Болеславе не
      разучились делать настоящие спортивные автомобили. Что в этом необычного,
      спросите вы? А то, что в современном мире часто бывает так, что свои
      «боевые» машины для участия в гонках известные всему миру
      автопроизводители заказывают на стороне, в небольших частных фирмах, где
      работают люди, которые в этом действительно знают толк. Заводское
      подразделение ŠKODA Motorsport разрабатывает и производит раллийные FABIA
      R5 самостоятельно и продаёт автомобили всем желающим. И желающие, конечно,
      есть. Сегодня FABIA R5 — один из самых удачных и титулованных раллийных
      автомобилей в мире. Чтобы не быть голословными, приведём список достижений
      ŠKODA Motorsport и лично FABIA R5 по итогам сезона 2016 года. Первое место
      в чемпионате мира по ралли в категории WRC 2, победа в
      Азиатско-Тихоокеанском чемпионате, в чемпионате Ближнего Востока и
      чемпионате Южной Америки, безоговорочное лидерство во многих национальных
      первенствах: Чехии, Германии, Бельгии, Словакии, Венгрии, Ирландии...
    </p>
    <p>
      Как вы, наверное, догадываетесь, из всех автоспортивных дисциплин ралли
      было выбрано ŠKODA неслучайно. Ведь что такое ралли? Вид гонок по дорогам
      общего пользования. То есть максимально приближённый к реальным условиям
      движения. Во всяком случае, начиналось всё именно так. Считается, что
      термин в нынешнем своём значении сформировался в начале XX века на Ралли
      Монте-Карло. Название этой гонки в истории ŠKODA имеет особое значение. В
      1936 году два энтузиаста из Чехословакии Зденек Поль и Ярослав Хаусман на
      двухместном ŠKODA POPULAR преодолели за четыре дня 3852 км. По пути от
      Афин до Монако они не получили ни единого штрафного очка, неожиданно для
      всех завоевав второе место в классе автомобилей с двигателем до 1500 куб.
      см. Вскоре в продажу поступила партия автомобилей специальной серии
      POPULAR SPORT MONTE CARLO. Жива память о том успехе и сегодня. Ему
      посвящены яркие дизайнерские спецверсии современных моделей — RAPID MONTE
      CARLO и YETI MONTE CARLO. Автомобили, которые дают вам возможность
      прикоснуться к знаменательному историческому событию, суть которого
      довольно проста. Верьте в себя, в свои силы, и всё получится. К восхищению
      окружающих.
    </p>
  </DefaultSectionText>
    </DefaultPaddedSection>
    <DefaultPaddedSection bgColor="#FFF" noPb mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading">
    ŠKODA — победители чемпионата мира по ралли 2015
  </DefaultSectionHeading>
    </DefaultPaddedSection>
    <VideoPlayer padding="16/9" previewSrc="/m/skoda_sport_2.jpg" videoSrc={{
      "video/mp4": "/m/skoda-sport-rally.mp4"
    }} mdxType="VideoPlayer" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      